export default __webpack_public_path__ + "static/media/suspend.7679de7d.jfif";